import { render, staticRenderFns } from "./StockHistoryTable.vue?vue&type=template&id=0e6ca158&"
import script from "./StockHistoryTable.vue?vue&type=script&lang=js&"
export * from "./StockHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports